"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    explore: { path: "/explore" },
    guestHome: {
        path: "/",
    },
    getHelp: {
        path: "/properties/get-help",
    },
    noProperty: {
        path: "/properties/no-property",
    },
    guestDocumentUploadDetail: {
        path: "/file/:id",
    },
    guestDocumentUploadFile: {
        path: "/view-file/:id",
    },
    guestElevationCertificates: {
        path: "/elevation-certificates",
    },
    guestUploadElevationCertificates: {
        path: "/upload-elevation-certificates",
    },
    residentProperty: {
        path: "/properties/:propertyId",
    },
    residentPropertyRedirect: {
        path: "/properties",
    },
    residentSavedView: {
        path: "/view/:savedViewId",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3Vlc3RzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9ndWVzdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxPQUFPLEVBQUUsRUFBRSxJQUFJLEVBQUUsVUFBVSxFQUFFO0lBQzdCLFNBQVMsRUFBRTtRQUNULElBQUksRUFBRSxHQUFHO0tBQ1Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxJQUFJLEVBQUUsc0JBQXNCO0tBQzdCO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsSUFBSSxFQUFFLHlCQUF5QjtLQUNoQztJQUNELHlCQUF5QixFQUFFO1FBQ3pCLElBQUksRUFBRSxXQUFXO0tBQ2xCO0lBQ0QsdUJBQXVCLEVBQUU7UUFDdkIsSUFBSSxFQUFFLGdCQUFnQjtLQUN2QjtJQUNELDBCQUEwQixFQUFFO1FBQzFCLElBQUksRUFBRSx5QkFBeUI7S0FDaEM7SUFDRCxnQ0FBZ0MsRUFBRTtRQUNoQyxJQUFJLEVBQUUsZ0NBQWdDO0tBQ3ZDO0lBQ0QsZ0JBQWdCLEVBQUU7UUFDaEIsSUFBSSxFQUFFLHlCQUF5QjtLQUNoQztJQUNELHdCQUF3QixFQUFFO1FBQ3hCLElBQUksRUFBRSxhQUFhO0tBQ3BCO0lBQ0QsaUJBQWlCLEVBQUU7UUFDakIsSUFBSSxFQUFFLG9CQUFvQjtLQUMzQjtDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgZXhwbG9yZTogeyBwYXRoOiBcIi9leHBsb3JlXCIgfSxcbiAgZ3Vlc3RIb21lOiB7XG4gICAgcGF0aDogXCIvXCIsXG4gIH0sXG4gIGdldEhlbHA6IHtcbiAgICBwYXRoOiBcIi9wcm9wZXJ0aWVzL2dldC1oZWxwXCIsXG4gIH0sXG4gIG5vUHJvcGVydHk6IHtcbiAgICBwYXRoOiBcIi9wcm9wZXJ0aWVzL25vLXByb3BlcnR5XCIsXG4gIH0sXG4gIGd1ZXN0RG9jdW1lbnRVcGxvYWREZXRhaWw6IHtcbiAgICBwYXRoOiBcIi9maWxlLzppZFwiLFxuICB9LFxuICBndWVzdERvY3VtZW50VXBsb2FkRmlsZToge1xuICAgIHBhdGg6IFwiL3ZpZXctZmlsZS86aWRcIixcbiAgfSxcbiAgZ3Vlc3RFbGV2YXRpb25DZXJ0aWZpY2F0ZXM6IHtcbiAgICBwYXRoOiBcIi9lbGV2YXRpb24tY2VydGlmaWNhdGVzXCIsXG4gIH0sXG4gIGd1ZXN0VXBsb2FkRWxldmF0aW9uQ2VydGlmaWNhdGVzOiB7XG4gICAgcGF0aDogXCIvdXBsb2FkLWVsZXZhdGlvbi1jZXJ0aWZpY2F0ZXNcIixcbiAgfSxcbiAgcmVzaWRlbnRQcm9wZXJ0eToge1xuICAgIHBhdGg6IFwiL3Byb3BlcnRpZXMvOnByb3BlcnR5SWRcIixcbiAgfSxcbiAgcmVzaWRlbnRQcm9wZXJ0eVJlZGlyZWN0OiB7XG4gICAgcGF0aDogXCIvcHJvcGVydGllc1wiLFxuICB9LFxuICByZXNpZGVudFNhdmVkVmlldzoge1xuICAgIHBhdGg6IFwiL3ZpZXcvOnNhdmVkVmlld0lkXCIsXG4gIH0sXG59KTtcbiJdfQ==